export default "a539eddbd1333599.svg"